<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <ng-container>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li
        nz-submenu
        [nzTitle]="'hinh_anh' | translate"
        [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="item" style="margin-bottom: 12%;">
          <!-- Upload input -->
          <input
            type="file"
            (change)="onUpload($event)"
            id="upload"
            style="display: none"
          />
          <nz-radio-group class="w-100" [(ngModel)]="config.isImageSaved">
            <label nz-radio [nzValue]="true" for="upload" class="radio-option-1">
              <button
                (click)="openUpload()"
                [disabled]="!config.isImageSaved"
                [ngClass]="{ disable: !config.isImageSaved }"
                class="upload-background-image"
                (change)="onUpload($event)"
              >
                <span><i class="bi bi-plus-circle"></i>{{'chon_anh_tu_thu_vien' | translate}}</span>
              </button>
            </label>
            <!-- Using image path -->
            <label nz-radio [nzValue]="false" class="radio-option-2" >
                <mat-form-field appearance="fill" class="text-field">
                  <mat-label>{{'su_dung_duong_dan_hinh_anh' | translate}}</mat-label>
                  <input
                    class="text"
                    type="text"
                    [placeholder]="'nhap_duong_dan' | translate"
                    [disabled]="config.isImageSaved"
                    matInput
                    [(ngModel)]="staticdata.img"
                    (ngModelChange)="updateObject()"
                    (blur)="updateObject()"
                  />
                </mat-form-field>
            </label>
          </nz-radio-group>
        </div>
      </li>
      <li
        nz-submenu
        [nzTitle]="'chon_popup_hien_thi' | translate"
        [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')"
      >
        <nz-select
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'chon_khoi_hien_thi' | translate"
          [(ngModel)]="staticdata.id_freeblock"
          (ngModelChange)="updateObject()"
        >
          <nz-option
            *ngFor="let block of blockList"
            [nzLabel]="block.name"
            [nzValue]="block._id"
          ></nz-option>
        </nz-select>
      </li>
      <li
        nz-submenu
        [nzTitle]="'chon_huong_popup_hien_thi' | translate"
        [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')"
      >
        <div>
          <nz-radio-group
            [(ngModel)]="objectChoosing.direction"
            (ngModelChange)="handleChangeDirection($event);updateObject()"
          >
            <label nz-radio nzValue="left">{{'trai' | translate}}</label>
            <label nz-radio nzValue="right">{{'phai' | translate}}</label>
            <label nz-radio nzValue="top">{{'tren' | translate}}</label>
            <label nz-radio nzValue="bottom">{{'duoi' | translate}}</label>
          </nz-radio-group>
        </div>
      </li>
    </ul>
  </ng-container>
</div>
